import React from 'react'
import './footer.css'
import {BsLinkedin, BsGithub, BsTwitter} from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer_logo">Sam Davey</a>

      <ul className="permalinks">
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer_socials">
        <a href="https://www.linkedin.com/in/sam-davey/" target="_blank"><BsLinkedin/></a>
        <a href="https://github.com/samodavey?tab=repositories" target="_blank"><BsGithub/></a>
        <a href="https://twitter.com/TravelWithDavey" target="_blank"><BsTwitter/></a>
      </div>

      <div className="footer_copyright">
        <small>&copy; Sam Davey. All rights reserved</small>
      </div>
    </footer>
  )
}

export default Footer
